export const keyframes: IKeyframes = {
  h1: {
    id: 'h1',
    ts: 2,
    type: 'hud',
    valuesKeyframe: { showHud: true },
  },
  k1: {
    id: 'k1',
    ts: 0,
    type: 'camera',
    valuesKeyframe: {
      radius: 25,
      alpha: 40,
      beta: 35,
    },
  },
  k2: {
    id: 'k2',
    ts: 2,
    type: 'camera',
    valuesKeyframe: {
      radius: 10,
      alpha: 31,
      beta: 32,
    },
  },
  sfx: {
    id: 'sfx',
    ts: 3.5,
    type: 'sfx',
    valuesKeyframe: {
      src: '/space-a.mp3',
    },
  },
  k3: {
    id: 'k3',
    ts: 4,
    type: 'camera',
    valuesKeyframe: {
      radius: 11,
      alpha: 36,
      beta: 155,
    },
  },
  k4: {
    id: 'k4',
    ts: 6.7,
    type: 'camera',
    valuesKeyframe: {
      radius: 14,
      alpha: 36,
      beta: 155,
    },
  },
  sfxb: {
    id: 'sfxb',
    ts: 8,
    type: 'sfx',
    valuesKeyframe: {
      src: '/space-b.mp3',
    },
  },
  k5: {
    id: 'k5',
    ts: 8.5,
    type: 'camera',
    valuesKeyframe: {
      radius: 10,
      alpha: 31,
      beta: 32,
    },
  },
  k7a: {
    id: 'k7a',
    ts: 11,
    type: 'camera',
    valuesKeyframe: {
      radius: 12,
      alpha: 31,
      beta: 32,
    },
  },
  k7: {
    id: 'k7',
    ts: 14,
    type: 'camera',
    valuesKeyframe: {
      radius: 10,
      alpha: 31,
      beta: 32,
    },
  },
  a2: {
    id: 'a2',
    ts: 1,
    type: 'audio',
    valuesKeyframe: { src: '/v-08.mp3' },
  },
  a3: {
    id: 'a3',
    ts: 3.5,
    type: 'audio',
    valuesKeyframe: { src: '/v-06a.mp3' },
  },
  a4: {
    id: 'a4',
    ts: 6.2,
    type: 'audio',
    valuesKeyframe: { src: '/v-06b.mp3' },
  },
  a6: {
    id: 'a6',
    ts: 9,
    type: 'audio',
    valuesKeyframe: { src: '/v-10a.mp3' },
  },
  a7: {
    id: 'a7',
    ts: 12.3,
    type: 'audio',
    valuesKeyframe: { src: '/v-10b.mp3' },
  },
};
